export default "__VITE_ASSET__ch0n07Ph__"